const $ = require('jquery')
const Vue = require('vue')
const moment = require('moment')

const toastr = require('toastr');

require('moment-range')

const vueChaos = require('sci/helpers/vue-chaos')
const client = require('sci/helpers/client')

const popoverTemplate = require('templates/properties/availability-popover.hbs')

const defaultValue = {
    initial: null,
    final: null,
    reason: 1,
    description: null
}

const popoverTitle = $(`<div class="row-fluid">Anotações <i class="fa fa-times close-popover pull-right"></i></div>`)

const disableDates = (self, vm) => {
    const disabledDates = vm.property.availabilities.reduce((dates, availability) => {
        const initial = moment(availability.initial)
        const final = moment(availability.final || availability.initial)

        let range = moment.range(initial, final);

        for( let day of range.by('day')) {
            const format = day.format('L')

            if (!dates.hasOwnProperty(format)) {
                dates[format] = []
            }

            dates[format].push(availability)
        }


        return dates
    }, {})

    $(self).find('.day').each(function () {
        $(this)
            .removeClass('disabled')
            .unbind()

        if (disabledDates.hasOwnProperty($(this).data('day'))) {
            const availabilities = disabledDates[$(this).data('day')]

            $(this)
                .addClass('disabled')
                .click(function () {
                    const it = $(this)

                    const title = popoverTitle.clone()

                    title.click(function () {
                        $(this).parents('.popover').popover('destroy')
                    })

                    const content = $(popoverTemplate({availabilities}))

                    content.find('.edit').click(function () {
                        const id = $(this).data('id')

                        vm.ui.availability = availabilities.filter((_) => _.id == id).shift()

                        $('#availabilities-modal').modal('show')

                        $(this).parents('.popover').popover('destroy')
                    })

                    content.find('.delete').click(function () {
                        const id = $(this).data('id')
                        const item = availabilities.filter((_) => _.id == id).shift()

                        client
                            .silent()
                            .delete(`Removendo <b>${item.description}</b>...`, `properties/${vm.property.id}/availabilities/${item.id}`)
                            .then(() => {
                                vm.property.availabilities.$remove(item)
                                disableDates(self, vm)
                            })

                        $(this).parents('.popover').popover('destroy')
                    })

                    it.popover({
                        title,
                        content,
                        html: true,
                        container: 'body'
                    }).popover('show')

                    $('body').one('click', function () {
                        it.popover('destroy')
                    })
                })
        } else {
            $(this).click(function (evt) {
                evt.preventDefault()
                return false
            })
        }
    })
}

const buildCalendar = (self) => {
    const $el = $('#property-availabilities-inline')

    if (!$el.length) {
        return
    }

    if ($el.data('DateTimePicker')) {
        $('#property-availabilities-inline')
            .datetimepicker('destroy')
    }

    $el.datetimepicker({
        inline: true,
        locale: 'pt-BR',
        format: 'L'
    }).on('dp.change', function () {
        disableDates($(this), self)
    }).on('dp.update', function () {
        disableDates($(this), self)
    })

    const dtp = $el.data('DateTimePicker')

    dtp.date(moment())
}

module.exports = {
    defaultValue,
    boot (self) {
        self.ui.loadingCalendar = true;
        if (self.property.availabilities) {
            setTimeout(() => {
                self.ui.loadingCalendar = false
                buildCalendar(self)
            }, 5000)
            // Vue.nextTick(() => buildCalendar(self))
        }

        self.$watch('property.for_vacation', function (newVal) {
            if (newVal) {
                buildCalendar(self)
            }
        })
    },
    methods: {
        saveAvailability () {
            const $form = $('#property-availability-editor')

            let promise = null
            let action = null
            let final = moment(this.ui.availability.final);
            let initial = moment(this.ui.availability.initial);
            if (final.diff(initial, 'days') < 0) {
                return toastr.error('Data final não pode ser maior que a data inicial.');
            }
            if (!this.ui.availability.id) {
                action = 'create'
                promise = client
                    .silent()
                    .post(`Salvando...`, `properties/${this.property.id}/availabilities`, this.ui.availability)
            } else {
                action = 'update'
                promise = client
                    .silent()
                    .put(`Salvando...`, `properties/${this.property.id}/availabilities/${this.ui.availability.id}`, this.ui.availability)
            }

            promise.then(vueChaos($form))
                .then((availability) => {
                    if (action === 'create') {
                        this.property.availabilities.push(availability)
                    }
                })
                .then((availability) => {
                    this.ui.availability = {...defaultValue}

                    $('#availabilities-modal').modal('hide')

                    buildCalendar(this)
                })
        },
        removeAvailability (availability) {
            client
                .silent()
                .delete(`Removendo <b>${availability.name}</b>...`, `properties/${this.property.id}/availabilities/${availability.id}`)
                .then(() => {
                    this.property.availabilities.$remove(availability)

                    buildCalendar(this)
                })
        }
    },
    watch: {
        'property.availabilities': {
            deep: true,
            handler: function () {
                buildCalendar(this);
            }
        },
        'ui.availability.initial' (newVal) {
            const oldFinal = this.ui.availability.final

            if (!oldFinal || oldFinal < newVal) {
                this.ui.availability.final = newVal
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/javascript/pages/old-properties/_editor/availabilities.js